export default __webpack_public_path__ + "static/media/changed.457779e7.png";